<!-- Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. -->
<h1>{{ appStrings.LOG_IN }}</h1>
<ng-container [ngSwitch]="loginType$ | async">
	<ng-container *ngSwitchCase="'ONLY_PASSWORD'">
		<ng-container [ngTemplateOutlet]="onlyPassword"></ng-container>
	</ng-container>
</ng-container>

<ng-template #onlyPassword>
	<form class="core-container-content" [formGroup]="signInForm" (ngSubmit)="onLoginWithEmailandPassword()">
		<mat-form-field>
			<mat-label>{{ appStrings.PASSWORD }}</mat-label>
			<input type="password" matInput autocomplete="password" autofocus formControlName="password" />
			<mat-error>{{ appStrings.FIELD_IS_REQUIRED }}</mat-error>
		</mat-form-field>
		<button-footer
			class="mat-form-field-compatible-spacing"
			[disabled]="!signInForm.valid"
			[saveOrCloseButtonText]="appStrings.LOG_IN"
		>
			<button type="button" leftButton (click)="onForgotPassword()" mat-stroked-button color="primary">
				{{ appStrings.FORGOT_PASSWORD }}
			</button>
		</button-footer>
	</form>
	<div class="back-button-container">
		<button mat-button color="primary" [routerLink]="'../login'" queryParamsHandling="preserve">
			{{ appStrings.UICONTROL_TEXT_GOBACK }}
		</button>
	</div>
</ng-template>
